// Shared "employee's own portal data" query. One `['employee', 'portal']`
// key for every consumer (Portal.tsx, the mobile Home/Maeve/Check-ins tabs)
// so they share one cache entry instead of independent fetches — same
// rationale as `use-cases.ts` for the Manager surfaces.

import { useQuery } from '@tanstack/react-query';
import type { EmployeePortal as EmployeePortalResponse } from '@besideu/shared/cases';
import { api } from '@/lib/api.ts';

export function useEmployeePortal() {
  return useQuery({
    queryKey: ['employee', 'portal'],
    queryFn: () => api.get<EmployeePortalResponse>('/api/employee/portal'),
  });
}
